import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/agent/comissions/comissions_report_detail/filter'; // Importing Filter component
import Table from 'views/agent/comissions/comissions_report_detail/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the deposit report view.
 * @extends JetView
 */
export default class depositReportView extends JetView {
    /**
     * Configures the UI components of the deposit report view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const toolbar = {
            view: 'toolbar', // Toolbar component
            id: 'toolbar', // Unique identifier for the toolbar
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                // Columns in the toolbar
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'], // Options for page size
                    width: 70, // Width of the dropdown
                    on: {
                        // Event handlers
                        onChange: function () {
                            // Change event for dropdown
                            $$('table').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('table').refresh(); // Refresh the table
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for pagination
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false, // Disable autosizing
                    height: 35, // Height of the pager
                    size: devConfig.getDefaultDataFetch(), // Default page size from config
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export', // Name of the dropdown
                    id: 'Export', // Unique identifier for the dropdown
                    width: 120, // Width of the dropdown
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        // Export options
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        // Event handlers
                        onChange: function (value) {
                            // Change event for export dropdown
                            var size = $$('table').getPager().config.size; // Get current page size
                            var page = $$('table').getPage(); // Get current page number
                            var first = size * page; // Calculate first item index
                            var last = first + size - 1; // Calculate last item index
                            if (value == 1) {
                                // If Excel is selected
                                var table = $$('table'); // Reference to the table
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    // Loop through columns
                                    if (table.config.columns[j].exportType) {
                                        // Check for export type
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filter: function (obj) {
                                        // Filter function for export
                                        return (
                                            $$('table').getIndexById(obj.id) >= first && // Include items in range
                                            $$('table').getIndexById(obj.id) <= last
                                        );
                                    },
                                    filename:
                                        'Virtualsoft - ' + // Filename for the export
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            }) // Format date
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1') // Date formatting
                                            .replace(/[\/:]/g, '_') // Replace slashes and colons
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('table').count() > 0 ? '' : _('No hay datos - ')) + // Check for data
                                        _('Comisiones Detallado'), // Report title
                                    ignore: { ActionTittle: true }, // Ignore specific column
                                    footer: false, // Do not include footer
                                });
                            } else {
                                if (value == 2) {
                                    // If PDF is selected
                                    webix.toPDF($$('table'), {
                                        // Export to PDF
                                        filter: function (obj) {
                                            // Filter function for export
                                            return (
                                                $$('table').getIndexById(obj.id) >= first && // Include items in range
                                                $$('table').getIndexById(obj.id) <= last
                                            );
                                        },
                                        filename:
                                            'Virtualsoft - ' + // Filename for the export
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                }) // Format date
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1') // Date formatting
                                                .replace(/[\/:]/g, '_') // Replace slashes and colons
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('table').count() > 0 ? '' : _('No hay datos - ')) + // Check for data
                                            _('Comisiones Detallado'), // Report title
                                        autowidth: true, // Enable auto width
                                        ignore: { ActionTittle: true }, // Ignore specific column
                                        footer: false, // Do not include footer
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export dropdown value
                        },
                    },
                },
            ],
        };
        const left = {
            rows: [
                // Left side layout
                {
                    view: 'toolbar', // Toolbar for search
                    css: theme, // Apply current theme
                    id: 'toolbar-search', // Unique identifier for the search toolbar
                    elements: [
                        // Elements in the search toolbar
                        {
                            view: 'label', // Label for the report title
                            label: _('Reporte de Comisiones Detallado'), // Title text
                        },
                        {
                            type: 'wide', // Wide button type
                            css: 'close-bottom', // CSS class for styling
                            id: 'button-search', // Unique identifier for the search button
                            cols: [
                                // Columns in the button
                                {
                                    view: 'icon', // Icon for the search button
                                    icon: 'wxi-search', // Icon type
                                    bottom: 20, // Bottom margin
                                    right: 35, // Right margin
                                    width: 30, // Width of the icon
                                    height: 30, // Height of the icon
                                    click: () => {
                                        // Click event for the icon
                                        $$('filterPopup').show(); // Show filter popup
                                    },
                                },
                            ],
                        },
                    ],
                },
                Filter, // Include Filter component
                Table, // Include Table component
                toolbar, // Include toolbar
            ],
        };
        webix.ui.fullScreen(); // Set UI to full screen mode
        return {
            // Return the main configuration object
            id: 'a5', // Unique identifier for the form
            type: 'clean', // Clean type for the form
            view: 'form', // Form view
            scroll: 'y', // Enable vertical scrolling
            rows: [
                // Rows in the form
                {
                    responsive: 'a5', // Responsive layout
                    type: 'wide', // Wide type
                    cols: [left], // Include left layout
                },
            ],
        };
    }

    /**
     * Initializes the deposit report view.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            // Execute when Webix is ready
            if (screen.width < 500 || screen.height < 500) {
                // Check for small screen size
                var childs = $$('toolbar').getChildViews(); // Get child views of the toolbar
                $$('toolbar').removeView(childs[2]); // Remove the third child view
                $$('pagerA').define('group', 1); // Define pager grouping
            }
            if (screen.width > 500 && screen.height > 500) {
                // Check for larger screen size
                $$('toolbar-search').hide(); // Hide the search toolbar
            }
            $.fn.scrollBottom = function () {
                // Add scrollBottom function to jQuery
                return $(document).height() - this.scrollTop() - this.height(); // Calculate scroll bottom position
            };
        });
    }
}

// FILE DOCUMENTED
